<template>
  <div class="text-slider" :style="{ height }">
    <nav class="text-slider__nodes">
      <button
        v-for="index in slides.length"
        :key="index"
        class="text-slider__goto"
        @click="handleGoToClick(index - 1)"
      />

      <span class="text-slider__goto -active" :style="activeNodeStyle" />
    </nav>

    <Transition
      v-if="currentSlide"
      name="text-slider"
      mode="out-in"
      :duration="425"
      appear
      @enter="setHeight"
    >
      <article ref="currentSlide" :key="currentSlide.id" class="text-slider__item">
        <img
          v-if="currentSlide.icon"
          :src="currentSlide.icon"
          alt=""
          class="text-slider__icon text-slider__shift"
        />

        <div class="text-slider__content text-slider__shift">
          <h4 class="text-slider__title">{{ currentSlide.title }}</h4>
          <p>{{ currentSlide.text }}</p>
        </div>
      </article>
    </Transition>

    <nav class="text-slider__menu">
      <button :class="getButtonClassName()" @click="handleNextClick">
        <Icon id="arrow" />
      </button>

      <button :class="getButtonClassName(true)" @click="handlePrevClick">
        <Icon id="arrow" />
      </button>
    </nav>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'TextSlider',
  components: { Icon },
  props: {
    slides: { type: Array, default: Array },
  },
  data() {
    return { currentSlideIndex: 0, height: 'auto' }
  },
  computed: {
    taggedSlides() {
      return this.slides.map((slide, slideI) => ({ ...slide, id: `x-${slideI}` }))
    },
    currentSlide() {
      return !this.taggedSlides.length ? null : this.taggedSlides[this.currentSlideIndex]
    },
    activeNodeStyle() {
      return { transform: `translate3d(${this.currentSlideIndex * 2.25}rem, 0, 0)` }
    },
  },
  methods: {
    setHeight() {
      this.$nextTick(() => {
        const { clientHeight } = this.$refs.currentSlide
        this.height = `${clientHeight + 24}px`
      })
    },
    getButtonClassName(isPrev) {
      return [
        'text-slider__button',
        {
          '-prev': isPrev,
          '-disabled': isPrev
            ? !this.currentSlideIndex
            : this.currentSlideIndex >= this.slides.length - 1,
        },
      ]
    },
    handleNextClick() {
      if (this.currentSlideIndex < this.slides.length - 1) this.currentSlideIndex += 1
    },
    handlePrevClick() {
      if (this.currentSlideIndex) this.currentSlideIndex -= 1
    },
    handleGoToClick(index) {
      this.currentSlideIndex = index
    },
  },
}
</script>
